import { UPDATE_ROOM_ERP_INTEGRATIONS_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class UpdateRoomErpIntegrationsError extends ApiError {
  constructor() {
    super(UPDATE_ROOM_ERP_INTEGRATIONS_ERROR);
  }
}
